import React, { useEffect, useState } from 'react';
import { IPlayerLevel } from 'utils/types';
import { StyledPlayerLevel, StyledTimeLeftValue } from './style';
import { Box } from '@mui/material';
import { calculateTimeLeftLabel } from '../utils';

const mapLengthToWidth: Record<number, string> = {
  7: '58px',
  6: '49px',
  5: '41px',
  4: '28px',
  3: '23px',
  2: '18px',
};

export const HeartOfVegasPlayerLevel: React.FC<IPlayerLevel> = ({
  assetUrl,
  text = '',
  endsIn = 0,
  onTimerDoneHandler,
}) => {
  const [timeLeftLabel, setTimeLeftLabel] = useState(
    calculateTimeLeftLabel({ endsIn, onTimerDoneHandler }),
  );

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeftLabel(calculateTimeLeftLabel({ endsIn, onTimerDoneHandler }));
    }, 1000);

    return () => clearInterval(timer);
  }, [endsIn]);

  return (
    <StyledPlayerLevel className={'player-level'}>
      <img className={'image'} src={assetUrl} alt={'value player level'} />
      {text && <div className="free-text">{text}</div>}
      {timeLeftLabel && (
        <Box className="ends-in-section" gap={'7px'}>
          <div className="text">ends in:</div>
          <StyledTimeLeftValue
            width={mapLengthToWidth[timeLeftLabel.length || 7] || '60px'}
          >
            {timeLeftLabel}
          </StyledTimeLeftValue>
        </Box>
      )}
    </StyledPlayerLevel>
  );
};
